<template lang="pug">
  .container
    .info
      img.banner(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/success.png")
      p 支付完成，请注意查收短信。
    .gzh
      .header
        .title
          | 关注
          span.name “冰蓝流量“
          | 微信公众号
        .desc 查询并领取30G国内通用流量
      .body
        ol
          li
            .text
              | 打开微信，搜索
              span.name “冰蓝流量”
              | 公众号
            .img
              img(src="../../../public/images/blll.png")
          li
            .text 关注公众号，进入查看“我的权益”
        el-button.btn-copy(@click="copyBLName") 一键复制并打开微信
        div(ref="blAccount", style="opacity: 0;") {{blAccount}}
</template>

<script>
export default {
  data() {
    return {
      shareNoticeVisiable: false,
      blAccount: 'meirxx'
    }
  },
  methods: {
    copyBLName() {
      let _range = document.createRange()
      _range.selectNode(this.$refs.blAccount)
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(_range);
      document.execCommand('Copy')
      window.getSelection().removeAllRanges()
      location.href = 'weixin://'
    },
    goRights() {
      this.$router.push({
        name: 'xjRights'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.info{
  font-size: 1.1rem;
  text-align: center;
  margin-top: 4rem;
  .banner{
    width: 64px;
    height: 64px;
  }
}
.btn-back{
  width: 50%;
  margin-top: 1rem;
}
.gzh{
  width: 90%;
  margin: 1rem auto;
  margin-top: 2rem;
}
.header{
  background-color: #41c1ac;
  color: #fff;
  text-align: center;
  font-size: 1.4rem;
  padding: .5rem 0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.body{
  padding: .5rem 1rem;
  border: 2px solid #41c1ac;
  padding-bottom: 1rem;
  img{
    width: 100%;
    margin: .4rem 0;
    box-shadow: 0 0 3px #a3a3a3;
  }
  ol{
    list-style-type: decimal;
    padding: 0 1rem;
    color: #41c1ac;
    font-size: 1.2rem;
    li{
      margin-top: 0.3rem;
    }
  }
}
.btn-copy{
  width: 100%;
  background-color: #E6A23C;
  color: #fff;
  font-size: 1.2rem;
  margin-top: 2rem;
  border-radius: 36px;
}
</style>